import { gql } from '@apollo/client'

export const GET_LIVE_AUCTION_SUMMARY = gql`
  subscription GetLiveAuctionSummary($input: oGetLiveAuctionSummaryInput) {
    getLiveAuctionSummary(input: $input) {
      eBidOperation
      aRecentPickPlayers {
        oPlayer {
          oImg {
            sUrl
            sText
          }
          sFullName
        }
        sPlayingRole
        eAuctionStatus
        nBasePrice
        nSoldPrice
        oTeam {
          oImg {
            sUrl
            sText
          }
          sAbbr
          oJersey {
            sUrl
            sText
          }
        }
        oPrimaryTeam {
          sTitle
          oImg {
            sUrl
            sText
          }
          oJersey {
            sUrl
            sText
          }
        }
        oCountry {
          sTitle
          oImg {
            sUrl
            sText
          }
        }
      }
      oCurrentPlayer {
        oPlayer {
          sFullName
          oImg {
            sUrl
            sText
          }
        }
        nBasePrice
        sPlayingRole
        oPrimaryTeam {
          sAbbr
          oImg {
            sUrl
            sText
          }
          oJersey {
            sUrl
            sText
          }
        }
        oCountry {
          sTitle
          oImg {
            sUrl
            sText
          }
        }
        aBid {
          nBidPrice
          oTeam {
            sTitle
            oImg {
              sUrl
              sText
            }
          }
          bSold
          bRTM
        }
        nSoldPrice
        eAuctionStatus
      }
    }
  }
`
